import { AlertTitle } from "@mui/material";
import { DefaultAlert } from "./Messages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createForm } from "@/hooks/form/source-data/useForm";
import { AppSettings } from "@/AppSettings";
import { FC } from "react";

interface IExcludedFormAlertProps {
    form: ReturnType<typeof createForm> | undefined;
}

const ExcludedFormAlert: FC<IExcludedFormAlertProps> = ({ form }) => {
    if (!form?.excluded) {
        return null;
    }

    return (
        <DefaultAlert sx={{ mb: -2 }} icon={<FontAwesomeIcon fixedWidth icon={AppSettings.icons.alertDefault} />}>
            <AlertTitle>Case Report Form Excluded</AlertTitle>
            <p>
                The case report form has been excluded from the selected participant allocation.
            </p>
            <p>
                <strong>Reason:</strong> {form.exclusionReason || "No reason provided."}
            </p>
            <p>Use the OpenClinica link above to view the form in OpenClinica.</p>
        </DefaultAlert>
    )
}

export default ExcludedFormAlert;